import React from 'react';
import { 
  Dialog,
  DialogActions,
  Typography,
  Grid
} from '@mui/material';
import { ActionButton } from '../../buttons/ButtonStyles';

export function DeleteComponentModal({ open, setOpen, onDelete }) {

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    setOpen(false);
    onDelete();
  };

  return (
    <Dialog 
        open={open} 
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            padding: '24px',
            border: '1px solid #3b82f6',
            borderRadius: '8px'
          }
        }}
    >
        <Grid className="p-6">
          <Typography variant="h6" className="text-center font-medium mb-6">
            Are you sure you want to delete this?
          </Typography>

          <DialogActions className="p-2 flex justify-between" sx={{ padding: '16px', marginTop: '16px', marginBottom: '24px' }}>
              <ActionButton variant="contained" onClick={handleClose}>
                  Cancel
              </ActionButton>
              <ActionButton variant="contained" onClick={handleDelete}>
                  Delete
              </ActionButton>
          </DialogActions>
        </Grid>
    </Dialog>
  );
}